import { scale } from '@cloudinary/url-gen/actions/resize';
import { Cloudinary } from '@cloudinary/url-gen';

export const devOnlyCloudinaryInstance = new Cloudinary({
  cloud: { cloudName: `mcm-dev` },
});

const stage = import.meta.env.VITE_STAGE === 'dev' ? 'dev' : 'prod';
export const cloudinaryInstance = new Cloudinary({
  cloud: { cloudName: `mcm-${stage}` },
});

export const cloudinaryImage1080Config = (cld: Cloudinary, imageId: string) => {
  return cld
    .image(imageId)
    .resize(scale().width(1920).height(1080))
    .quality(50)
    .toURL();
};

export const cloudinaryImage720Config = (cld: Cloudinary, imageId: string) => {
  return cld
    .image(imageId)
    .resize(scale().width(1280).height(720))
    .quality(50)
    .toURL();
};

export const cloudinaryImageThumbnailConfig = (
  cld: Cloudinary,
  imageId: string
) => {
  return cld
    .image(imageId)
    .resize(scale().width(438).height(254))
    .quality(50)
    .toURL();
};
